import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import MapaCulturalPiaui from './components/MapaCultural/mapaCulturalPiaui';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

// ── V-06 FIX: Code Splitting ──
// Rotas administrativas carregadas dinamicamente (lazy) para que o código
// do painel admin não seja incluído no bundle principal (main.js).
// Isso impede que atacantes descubram rotas e lógica admin inspecionando o JS.
const AdminLayout = React.lazy(() => import('./pages/Admin/AdminLayout'));
const Dashboard = React.lazy(() => import('./pages/Admin/Dashboard'));
const Events = React.lazy(() => import('./pages/Admin/Events'));
const Metrics = React.lazy(() => import('./pages/Admin/Metrics'));
const Feedbacks = React.lazy(() => import('./pages/Admin/Feedbacks'));
const ErrorReports = React.lazy(() => import('./pages/Admin/ErrorReports'));
const Login = React.lazy(() => import('./pages/Admin/Login'));
const About = React.lazy(() => import('./pages/About/About'));

// Fallback de carregamento para as rotas lazy
const AdminLoadingFallback = () => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    background: '#0f172a',
    color: '#94a3b8',
    fontFamily: 'system-ui, sans-serif',
    fontSize: '0.9rem'
  }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{
        width: 32, height: 32,
        border: '3px solid #334155',
        borderTopColor: '#06b6d4',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
        margin: '0 auto 12px'
      }} />
      Carregando...
    </div>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<MapaCulturalPiaui />} />
            <Route path="/sobre" element={
              <Suspense fallback={<AdminLoadingFallback />}>
                <About />
              </Suspense>
            } />
            <Route path="/admin/login" element={
              <Suspense fallback={<AdminLoadingFallback />}>
                <Login />
              </Suspense>
            } />
            <Route path="/admin" element={
              // ── V-06 FIX: ProtectedRoute verifica sessão e role de admin
              // ANTES de renderizar o Suspense. Isso garante que os chunks
              // lazy do painel admin só são baixados por usuários autorizados.
              <ProtectedRoute>
                <Suspense fallback={<AdminLoadingFallback />}>
                  <AdminLayout />
                </Suspense>
              </ProtectedRoute>
            }>
              <Route index element={
                <Suspense fallback={<AdminLoadingFallback />}>
                  <Dashboard />
                </Suspense>
              } />
              <Route path="dashboard" element={
                <Suspense fallback={<AdminLoadingFallback />}>
                  <Dashboard />
                </Suspense>
              } />
              <Route path="events" element={
                <Suspense fallback={<AdminLoadingFallback />}>
                  <Events />
                </Suspense>
              } />
              <Route path="metrics" element={
                <Suspense fallback={<AdminLoadingFallback />}>
                  <Metrics />
                </Suspense>
              } />
              <Route path="feedbacks" element={
                <Suspense fallback={<AdminLoadingFallback />}>
                  <Feedbacks />
                </Suspense>
              } />
              <Route path="errors" element={
                <Suspense fallback={<AdminLoadingFallback />}>
                  <ErrorReports />
                </Suspense>
              } />
            </Route>
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
